<template>
    <div>
        {{ $t('Unsupported item type: {type}', {type: item.type}) }}
    </div>
</template>

<script>
    export default {
        props: {
            item: {
                type: Object,
                required: true,
            },
            resource: {
                type: Object,
                default: null,
            },
        },
    };
</script>
